export default __webpack_public_path__ + "8d2a45c5121b06134a80756651c2b835.png";